import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState, useCallback } from 'react';
import { IPublicEnumPluginRegisterLevel } from '@alilc/lowcode-types';

/**
 * 高阶组件（HOC）：为组件提供 view 插件上下文。
 *
 * @param {React.ComponentType} Component - 需要被封装的组件。
 * @param {string|string[]} viewName - 视图名称或视图名称数组，用于过滤特定的视图插件上下文。
 * @returns {React.ComponentType} 返回封装后的组件。
 *
 * @example
 * // 用法示例（函数组件）:
 * const EnhancedComponent = ProvideViewPluginContext(MyComponent, "viewName");
 */
export var ProvideViewPluginContext = function ProvideViewPluginContext(Component, viewName) {
  // 创建一个新的函数组件，以便在其中使用 Hooks
  return function WithPluginContext(props) {
    var _props$pluginContext;
    var getPluginContextFun = useCallback(function (editorWindow) {
      if (!(editorWindow !== null && editorWindow !== void 0 && editorWindow.currentEditorView)) {
        return null;
      }
      if (viewName) {
        var items = editorWindow === null || editorWindow === void 0 ? void 0 : editorWindow.editorViews.filter(function (d) {
          return d.viewName === viewName || Array.isArray(viewName) && viewName.includes(d.viewName);
        });
        return items[0];
      } else {
        return editorWindow.currentEditorView;
      }
    }, []);
    var _ref = props.pluginContext || {},
      workspace = _ref.workspace;
    var _useState = useState(getPluginContextFun(workspace === null || workspace === void 0 ? void 0 : workspace.window)),
      pluginContext = _useState[0],
      setPluginContext = _useState[1];
    useEffect(function () {
      if (workspace !== null && workspace !== void 0 && workspace.window) {
        var ctx = getPluginContextFun(workspace.window);
        ctx && setPluginContext(ctx);
      }
      return workspace === null || workspace === void 0 ? void 0 : workspace.onChangeActiveEditorView(function () {
        var ctx = getPluginContextFun(workspace.window);
        ctx && setPluginContext(ctx);
      });
    }, [workspace, getPluginContextFun]);
    if (((_props$pluginContext = props.pluginContext) === null || _props$pluginContext === void 0 ? void 0 : _props$pluginContext.registerLevel) !== IPublicEnumPluginRegisterLevel.Workspace || !props.pluginContext) {
      return /*#__PURE__*/React.createElement(Component, props);
    }
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      pluginContext: pluginContext
    }));
  };
};